// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_17_2-radio,
.perxis-auto-1_17_2-radio-group {
  /* Typography */
  --perxis-auto-radio-font-family-inner: var(
    --perxis-auto-radio-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-radio-font-size-inner: var(
    --perxis-auto-radio-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-radio-font-weight-inner: var(
    --perxis-auto-radio-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-radio-letter-spacing-inner: var(
    --perxis-auto-radio-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-radio-line-height-inner: var(
    --perxis-auto-radio-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-radio-text-transform-inner: var(
    --perxis-auto-radio-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-radio-font-variant-numeric-inner: var(
    --perxis-auto-radio-font-variant-numeric,
    var(--perxis-auto-root-typography-main-font-variant-numeric-inner)
  );
  --perxis-auto-radio-color-inner: var(
    --perxis-auto-radio-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-radio-disabled-color-inner: var(
    --perxis-auto-radio-disabled-color,
    var(--perxis-auto-root-typography-color-light-inner)
  );
  --perxis-auto-radio-error-color-inner: var(
    --perxis-auto-radio-error-color,
    var(--perxis-auto-radio-third-color-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-radio-first-color-inner: var(
    --perxis-auto-radio-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-radio-second-color-inner: var(
    --perxis-auto-radio-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-radio-third-color-inner: var(
    --perxis-auto-radio-third-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-radio-fourth-color-inner: var(
    --perxis-auto-radio-fourth-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-radio-fifth-color-inner: var(
    --perxis-auto-radio-fifth-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-radio-background-color-inner: var(
    --perxis-auto-radio-background-color,
    var(--perxis-auto-radio-first-color-inner)
  );
  --perxis-auto-radio-disabled-background-color-inner: var(
    --perxis-auto-radio-disabled-background-color,
    var(--perxis-auto-radio-fifth-color-inner)
  );
  --perxis-auto-radio-disabled-checked-background-color-inner: var(
    --perxis-auto-radio-disabled-checked-background-color,
    var(--perxis-auto-radio-fifth-color-inner)
  );
  --perxis-auto-radio-checked-background-color-inner: var(
    --perxis-auto-radio-checked-background-color,
    var(--perxis-auto-radio-third-color-inner)
  );
  --perxis-auto-radio-hover-background-color-inner: var(
    --perxis-auto-radio-hover-background-color,
    var(--perxis-auto-radio-first-color-inner)
  );
  --perxis-auto-radio-hover-checked-background-color-inner: var(
    --perxis-auto-radio-hover-checked-background-color,
    var(--perxis-auto-radio-third-color-inner)
  );
  --perxis-auto-radio-check-background-color-inner: var(
    --perxis-auto-radio-check-background-color,
    var(--perxis-auto-radio-first-color-inner)
  );
  --perxis-auto-radio-check-disabled-background-color-inner: var(
    --perxis-auto-radio-check-disabled-background-color,
    var(--perxis-auto-radio-fourth-color-inner)
  );
  --perxis-auto-radio-check-hover-background-color-inner: var(
    --perxis-auto-radio-check-hover-background-color,
    var(--perxis-auto-radio-first-color-inner)
  );
  --perxis-auto-radio-border-color-inner: var(
    --perxis-auto-radio-border-color,
    var(--perxis-auto-radio-fourth-color-inner)
  );
  --perxis-auto-radio-disabled-border-color-inner: var(
    --perxis-auto-radio-disabled-border-color,
    var(--perxis-auto-radio-fourth-color-inner)
  );
  --perxis-auto-radio-disabled-checked-border-color-inner: var(
    --perxis-auto-radio-disabled-checked-border-color,
    var(--perxis-auto-radio-fourth-color-inner)
  );
  --perxis-auto-radio-checked-border-color-inner: var(
    --perxis-auto-radio-checked-border-color,
    var(--perxis-auto-radio-third-color-inner)
  );
  --perxis-auto-radio-error-border-color-inner: var(
    --perxis-auto-radio-error-border-color,
    var(--perxis-auto-radio-third-color-inner)
  );
  --perxis-auto-radio-hover-border-color-inner: var(
    --perxis-auto-radio-hover-border-color,
    var(--perxis-auto-radio-second-color-inner)
  );
  --perxis-auto-radio-hover-checked-border-color-inner: var(
    --perxis-auto-radio-hover-checked-border-color,
    var(--perxis-auto-radio-third-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-radio-border-radius-inner: var(--perxis-auto-radio-border-radius, 50%);
  --perxis-auto-radio-border-width-inner: var(--perxis-auto-radio-border-width, 2px);
  /* End Border */
  /* Sizes */
  --perxis-auto-radio-width-inner: var(--perxis-auto-radio-width, 32px);
  --perxis-auto-radio-height-inner: var(--perxis-auto-radio-height, 32px);
  --perxis-auto-radio-check-width-inner: var(
    --perxis-auto-radio-check-width,
    calc(var(--perxis-auto-radio-width-inner) / 2.6)
  );
  --perxis-auto-radio-check-height-inner: var(
    --perxis-auto-radio-check-height,
    calc(var(--perxis-auto-radio-height-inner) / 2.6)
  );
  --perxis-auto-radio-gap-inner: var(--perxis-auto-radio-gap, 10px);
  --perxis-auto-radio-padding-inner: var(--perxis-auto-radio-padding, 0 5px 0 12px);
  /* End Sizes */
  /* Opacity */
  --perxis-auto-radio-opacity-inner: var(--perxis-auto-radio-opacity, 1);
  --perxis-auto-radio-hover-opacity-inner: var(--perxis-auto-radio-hover-opacity, 1);
  --perxis-auto-radio-disabled-opacity-inner: var(--perxis-auto-radio-disabled-opacity, 1);
  /* End Opacity */
}

.perxis-auto-1_17_2-radio {
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_17_2-radio[ant-5_24_1-click-animating-without-extra-node=true]::after,
.perxis-auto-1_17_2-radio > *[ant-5_24_1-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_17_2-radio .ant-5_24_1-wave {
  transition: none !important;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  margin: 0;
  font-family: var(--perxis-auto-radio-font-family-inner);
  font-size: var(--perxis-auto-radio-font-size-inner);
  line-height: var(--perxis-auto-radio-line-height-inner);
  font-weight: var(--perxis-auto-radio-font-weight-inner);
  text-transform: var(--perxis-auto-radio-text-transform-inner);
  letter-spacing: var(--perxis-auto-radio-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-radio-font-variant-numeric-inner);
  color: var(--perxis-auto-radio-color-inner);
  word-break: break-word;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio-input:focus + .ant-5_24_1-radio-inner {
  box-shadow: none;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper span.ant-5_24_1-radio + * {
  padding-inline: initial;
  padding: var(--perxis-auto-radio-padding-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio {
  top: 0;
  font-family: var(--perxis-auto-radio-font-family-inner);
  font-size: var(--perxis-auto-radio-font-size-inner);
  font-variant-numeric: var(--perxis-auto-radio-font-variant-numeric-inner);
  line-height: var(--perxis-auto-radio-line-height-inner);
  font-weight: var(--perxis-auto-radio-font-weight-inner);
  text-transform: var(--perxis-auto-radio-text-transform-inner);
  letter-spacing: var(--perxis-auto-radio-letter-spacing-inner);
  color: var(--perxis-auto-radio-color-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper:hover .ant-5_24_1-radio .ant-5_24_1-radio-inner,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio:hover .ant-5_24_1-radio-inner,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio-input:focus + .ant-5_24_1-radio-inner {
  background-color: var(--perxis-auto-radio-hover-background-color-inner);
  border-color: var(--perxis-auto-radio-hover-border-color-inner);
  opacity: var(--perxis-auto-radio-hover-opacity-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper:hover .ant-5_24_1-radio.ant-5_24_1-radio-checked .ant-5_24_1-radio-inner,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-checked:hover .ant-5_24_1-radio-inner,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-input:focus + .ant-5_24_1-radio-inner {
  background-color: var(--perxis-auto-radio-hover-checked-background-color-inner);
  border-color: var(--perxis-auto-radio-hover-checked-border-color-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper:hover .ant-5_24_1-radio.ant-5_24_1-radio-checked .ant-5_24_1-radio-inner::after,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-checked:hover .ant-5_24_1-radio-inner::after,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-input:focus + .ant-5_24_1-radio-inner::after {
  background-color: var(--perxis-auto-radio-check-hover-background-color-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-checked .ant-5_24_1-radio-inner {
  background-color: var(--perxis-auto-radio-checked-background-color-inner);
  border-color: var(--perxis-auto-radio-checked-border-color-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-checked .ant-5_24_1-radio-inner::after {
  background-color: var(--perxis-auto-radio-check-background-color-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-disabled + span {
  color: var(--perxis-auto-radio-disabled-color-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-disabled .ant-5_24_1-radio-input {
  cursor: not-allowed;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-disabled .ant-5_24_1-radio-inner {
  background-color: var(--perxis-auto-radio-disabled-background-color-inner) !important;
  border-color: var(--perxis-auto-radio-disabled-border-color-inner) !important;
  opacity: var(--perxis-auto-radio-disabled-opacity-inner);
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-disabled .ant-5_24_1-radio-inner::after {
  background-color: var(--perxis-auto-radio-check-disabled-background-color-inner) !important;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio.ant-5_24_1-radio-disabled.ant-5_24_1-radio-checked .ant-5_24_1-radio-inner {
  background-color: var(--perxis-auto-radio-disabled-checked-background-color-inner) !important;
  border-color: var(--perxis-auto-radio-disabled-checked-border-color-inner) !important;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio-inner {
  position: relative;
  width: var(--perxis-auto-radio-width-inner);
  height: var(--perxis-auto-radio-height-inner);
  background-color: var(--perxis-auto-radio-background-color-inner);
  border-width: var(--perxis-auto-radio-border-width-inner);
  border-style: solid;
  border-color: var(--perxis-auto-radio-border-color-inner);
  border-radius: var(--perxis-auto-radio-border-radius-inner);
  opacity: var(--perxis-auto-radio-opacity-inner);
  transition: all 0.2s;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio-inner::after {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
  width: var(--perxis-auto-radio-check-width-inner);
  height: var(--perxis-auto-radio-check-height-inner);
  background-color: transparent;
  border-radius: var(--perxis-auto-radio-border-radius-inner);
  margin: 0;
  transition: all 0.2s;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper::after,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio::after,
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper .ant-5_24_1-radio-checked::after {
  content: none;
}
.perxis-auto-1_17_2-radio.ant-5_24_1-radio-wrapper a {
  color: inherit;
  text-decoration: underline;
  font-weight: normal;
}

.ant-5_24_1-form-item-has-error .perxis-auto-1_17_2-radio .ant-5_24_1-radio + span {
  color: var(--perxis-auto-radio-error-color-inner);
}
.ant-5_24_1-form-item-has-error .perxis-auto-1_17_2-radio .ant-5_24_1-radio .ant-5_24_1-radio-inner {
  border-color: var(--perxis-auto-radio-error-border-color-inner);
}

.perxis-auto-1_17_2-radio-group.ant-5_24_1-radio-group {
  display: inline-grid;
  gap: var(--perxis-auto-radio-gap-inner);
  font-family: var(--perxis-auto-radio-font-family-inner);
  font-size: var(--perxis-auto-radio-font-size-inner);
  font-variant-numeric: var(--perxis-auto-radio-font-variant-numeric-inner);
  line-height: var(--perxis-auto-radio-line-height-inner);
  font-weight: var(--perxis-auto-radio-font-weight-inner);
  text-transform: var(--perxis-auto-radio-text-transform-inner);
  letter-spacing: var(--perxis-auto-radio-letter-spacing-inner);
  color: var(--perxis-auto-radio-color-inner);
  word-break: break-word;
}
.perxis-auto-1_17_2-radio-group.perxis-auto-1_17_2-radio-group--horizontal {
  grid-auto-flow: column;
}
.perxis-auto-1_17_2-radio-group.perxis-auto-1_17_2-radio-group--vertical {
  grid-auto-flow: row;
}
.perxis-auto-1_17_2-radio-group.perxis-auto-1_17_2-radio-group--flex {
  display: flex;
  flex-wrap: wrap;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
